<div class="record-table card-x">
    <p-table [value]="tableData" [loading]="isTableLoading" dataKey="id" [paginator]="true" [rows]="10"
        [totalRecords]="totalRecords" (onPage)="onPage($event)" [rowsPerPageOptions]="[5, 10, 20]" [pageLinks]="4"
        [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} items"
        [expandedRowKeys]="expandedRows" (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse($event)"
        styleClass="table-dark-header" 
        [sortField]="sortField"
        [sortMode]="'single'"
        [customSort]="true"
        [sortOrder]="sortOrder"
        (onSort)="onSort($event)">

        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'formattedId'">
                    Request Number
                    <p-sortIcon field="formattedId"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'recordSubject'">
                    Record Subject
                    <p-sortIcon field="recordSubject"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'providerName'">
                    Provider Name (Institution) / Doctor
                    <p-sortIcon field="providerName"></p-sortIcon>
                </th>
                <th style="width:25%" [pSortableColumn]="'address'">
                    Address / Email ID
                    <p-sortIcon field="address"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'recordRequestType'">
                    Record Request Type
                    <p-sortIcon field="recordRequestType"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'dateOfServices'">
                    Date of Services
                    <p-sortIcon field="dateOfServices"></p-sortIcon>
                </th>
                <th alignFrozen="right" pFrozenColumn style="width: 5rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" #body let-rowData let-expanded="expanded">
            <tr>
                <td data-label="Order Number">{{ rowData.formattedId }}</td>
                <td data-label="Record Subject">{{ rowData.recordSubject }}</td>
                <td data-label="Provider Name (Institution) / Doctor">
                    <div class="d-flex flex-column">
                        <label>{{ rowData.providerName }}</label>
                        <label>{{ rowData.doctor || '--'}}</label>
                    </div>
                </td>
                <td data-label="Address / Email">
                    <div class="d-flex flex-column">
                        <label>{{ rowData.address }}</label>
                        <label>{{ rowData.email }}</label>
                    </div>
                </td>
                <td data-label="Record Request Type">{{ rowData.recordRequestType }}</td>
                <td data-label="Date of Services">{{ rowData.dateOfServices }}</td>
                <!-- <td data-label="Uploaded Documents">
                    @if(rowData.documents.length){
                    <i tabIndex="0" class="pi pi-check success-color fw-bold" ></i>
                    } @else {
                    --
                    }
                </td> -->
                <td>
                    <div class="d-flex flex-row gap-3">
                        <p-button type="button" tabIndex="0" [text]="true" styleClass="primary-color fw-bold"
                            [link]="true" icon="pi pi-download" (click)="downloadMultipleFiles(rowData)"
                            [disabled]="!hasDocs()" />
                        <p-button type="button" tabIndex="0" [pRowToggler]="rowData" [text]="true" [link]="true"
                            [icon]="expanded ? 'pi pi-chevron-circle-up icon-color fs-6 fw-bold px-1' : 'pi pi-chevron-circle-down icon-color fs-6 fw-bold px-1'" />
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #expandedrow let-rowData>
            <tr class="p-0">
                <td [attr.colspan]="8" class="p-0 expanded">
                    <div class="p-3 bg-pale-blue w-100">
                        <p-panel [toggleable]="true" [(collapsed)]="rowData.additionalInfo.isCollapsed"
                            [showHeader]="rowData.additionalInfo.isCollapsed" class="custom-panel">
                            <ng-template pTemplate="header">
                                <button *ngIf="rowData.additionalInfo.isCollapsed" pButton
                                    (click)="togglePanel(rowData.additionalInfo, $event)" class="p-button-text p-0 m-0">
                                    View Additional Details <i class="pi pi-angle-down"></i>
                                </button>
                            </ng-template>
                            <!-- Replace the static content with dynamic binding -->
                            <div>
                                <label class="medium-text">Additional Details:</label>
                                <ul>
                                    @if(rowData.additionalInfo.details?.imaging){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Type of Imaging:</label>
                                        <div>
                                            <span>{{rowData.additionalInfo.details.imaging.type}}</span>
                                        </div>
                                        @if(rowData.additionalInfo.details?.imaging.bodyPart){
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Specific Body Part/Area: </span>
                                                {{rowData.additionalInfo.details.imaging.bodyPart}}
                                            </label>
                                        </div>
                                        }
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.ambulance){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Ambulance: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Date of Ambulance Service: </span>
                                                {{rowData.additionalInfo.details.ambulance.dateOfService}}
                                            </label>
                                        </div>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Time of ambulance service: </span>
                                                {{rowData.additionalInfo.details.ambulance.timeOfService}}
                                            </label>
                                        </div>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Pick-up Address: </span>
                                                {{rowData.additionalInfo.details.ambulance.pickupAddress}}
                                            </label>
                                        </div>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Drop Address: </span>
                                                {{rowData.additionalInfo.details.ambulance.dropAddress}}
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.employment){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Employment: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">SS#: </span>
                                                {{rowData.additionalInfo.details.employment.ssn}}
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.insurance){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Insurance: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Claim Number: </span>
                                                {{rowData.additionalInfo.details.insurance.claimNumber}}
                                            </label>
                                        </div>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Policy Number: </span>
                                                {{rowData.additionalInfo.details.insurance.policyNumber}}
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.irs){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">IRS: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">SS#: </span>
                                                {{rowData.additionalInfo.details.irs.ssn}}
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.military){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Military: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Branch (if known): </span>
                                                {{rowData.additionalInfo.details.military.branch}}
                                            </label>
                                        </div>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Service Number (if known): </span>
                                                {{rowData.additionalInfo.details.military.serviceNumber}}
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.socialSecurity){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Social Security: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">SS#: </span>
                                                {{rowData.additionalInfo.details.socialSecurity.ssn}}
                                            </label>
                                        </div>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Record Subject Address: </span>
                                                {{rowData.additionalInfo.details.socialSecurity.address}}
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.union){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Union: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Membership Number (if known): </span>
                                                {{rowData.additionalInfo.details.union.membershipNumber}}
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.va){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">VA: </label>
                                        <div>
                                            <label>{{rowData.additionalInfo.details.va.details}}</label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.other){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Other: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Description of records: </span>
                                                {{rowData.additionalInfo.details.other.recordDescription}}
                                            </label>
                                        </div>
                                    </li>
                                    }
                                </ul>
                            </div>
                            <ng-template pTemplate="footer">
                                <button *ngIf="!rowData.additionalInfo.isCollapsed" pButton
                                    (click)="togglePanel(rowData.additionalInfo, $event)" class="p-button-text">
                                    Hide Additional Details <i class="pi pi-angle-up"></i>
                                </button>
                            </ng-template>
                        </p-panel>
                        <div class="d-flex flex-column gap-2 mt-3">
                            <label class="semi-bold-text">Records Retrieved:</label>
                            @if (isDocumentsLoading) {
                                <div class="d-flex align-items-center gap-2">
                                    <i class="pi pi-spin pi-spinner"></i>
                                    <span>Loading documents...</span>
                                </div>
                            } @else if (rowData.documents?.length) {
                                @for(file of rowData.documents; let indx = $index; track file){
                                <div class="row">
                                    <div class="col-8 col-md-4 col-lg-4 text-truncate">
                                        <button pButton class="p-button-text p-0 m-0" (click)="downloadFile(file)">
                                            {{file.fileName}}
                                        </button>
                                    </div>
                                    <div class="col-1 col-md-2 col-lg-1">
                                        <p-button tabIndex="0" icon="pi pi-download" label=" Download" styleClass="p-0"
                                            (click)="downloadFile(file)" [link]="true" />
                                    </div>
                                </div>
                                }
                            } @else {
                                <div class="text-muted">
                                    No documents have been retrieved yet.
                                </div>
                            }
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>